/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterbtnlabelios3Inputs */



/**
* | output |
* | --- |
* | "SUBSCRIPTION" |
*
* @param {Monsterbtnlabelios3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterbtnlabelios3 = /** @type {((inputs?: Monsterbtnlabelios3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterbtnlabelios3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("SUBSCRIPTION")
	if (locale === "es") return /** @type {LocalizedString} */ ("SUSCRIPCIÓN")
	return /** @type {LocalizedString} */ ("ПОДПИСКА")
});
export { monsterbtnlabelios3 as "monsterBtnLabelIos" }